import { toast } from 'react-toastify';

export const defaultMessage = message =>
  toast(message, {
    progressStyle: {
      background: 'var(--falcon-ourcolor-1)',
      accentColor: 'var(--falcon-ourcolor-2)'
    }
  });
export const successMessage = message =>
  toast.success(message, {
    // theme: 'light'
  });
export const errorMessage = message => toast.error(message);
export const warningMessage = message => toast.warn(message);
